import { useQuery } from "react-query";

import { useOrg, useTimeLookbackRange } from "@hooks";

import { fetchRuleStats } from "../api";
import { RulesEventType } from "../types";

export const useRuleStats = (
  tab: RulesEventType,
  reposFilter: string[],
  until: number,
  limit: number
) => {
  const org = useOrg();
  const { tlr } = useTimeLookbackRange();

  return useQuery(
    ["RuleStats", org, tlr, tab, reposFilter, limit],
    () => fetchRuleStats(org!.id, tab, tlr, reposFilter, until, limit),
    {
      enabled: !!org,
    }
  );
};
